const classes = Object.freeze({
  modal: {
    root: 'modal-root',
    backdrop: 'modal-backdrop',
    content: 'modal-content',
    header: 'modal-header',
    borderHeader: 'modal-border-header',
    borderFooter: 'modal-border-footer',
    body: 'modal-body',
    footer: 'modal-footer',
    title: 'modal-title',
    full: 'modal-full',
    left: 'modal-left',
    right: 'modal-right'
  },
  textBox: {
    container: 'text-box-container',
    input: 'text-box',
    label: 'text-box-label',
    prefix: 'text-box-prefix',
    suffix: 'text-box-suffix',
    hasPrefix: 'text-box-has-prefix',
    hasSuffix: 'text-box-has-suffix',
    readOnly: 'text-box-read-only',
    error: 'text-box-error',
    focus: 'text-box-focus'
  },
  comboBox: {
    container: 'combo-box-container',
    root: 'combo-box',
    inputContainer: 'combo-box-input-container',
    menu: 'combo-box-menu',
    placeholder: 'combo-box-placeholder',
    outline: 'combo-box-outline'
  },
  datePicker: {
    calendar: 'datepicker-body',
    day: 'datepicker-day',
    month: 'datepicker-month',
    weekday: 'datepicker-weekday'
  }
});

export default classes;
